import { Component } from "@angular/core";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { AdminUnauthorizedComponent } from "../admin-unauthorized.component";
import { AuthService } from "@ponder-core/auth/auth.service";
import { UserPermissionType } from "@apiserver-rest/ponder-auth-client-base";
import { RoleAndPermissions } from "@ponder-core/auth/role-permissions";
import { AdminMagicViewSet } from "./admin-magic-view-set.component";
import { AdminMagicAddSetComponent } from "./admin-magic-add-set.component";

@Component({
    selector: "admin-magic",
    imports: [LoadingComponent, AdminUnauthorizedComponent, AdminMagicViewSet, AdminMagicAddSetComponent],
    templateUrl: "./admin-magic.component.html"
})
export class AdminMagicComponent {
    public loadingCanView: boolean = true;
    public canView: boolean = false;

    public constructor(private authService: AuthService) {

    }

    public ngOnInit(): void {
        this.authService.getRoleAndPermissions().then((roleAndPermissions?: RoleAndPermissions) => {
            this.canView = roleAndPermissions?.hasPermission(UserPermissionType.EditMagic) == true;
            this.loadingCanView = false;
        });
    }
}